module.exports = __webpack_public_path__ + "static/media/box-sucesso-mobile.d3e8b586.jpg";